//@ts-nocheck
import React, { useState } from "react";

import { ThemeProvider } from "@mui/material/styles";

import {
  theme as KoneTheme,
  WithAuthenticatorProps,
} from "@konecorp/ui-library";

import GlobalStateProvider from "../../context/globalState";

import KoneEmployeeApp from "../KoneEmployeeApp";
import LoginChooser, { AuthPath, readAuthPath } from "../LoginChooser";
import SubcontractorApp from "../SubcontractorApp";

const props = {} as WithAuthenticatorProps;

const App = (): JSX.Element => {
  const [authPath, setAuthPath] = useState<AuthPath | null>(() => readAuthPath());

  if (!authPath) {
    return <LoginChooser onPick={setAuthPath} />;
  }

  if (authPath === "subcontractor") {
    return (
      <GlobalStateProvider>
        <SubcontractorApp />
      </GlobalStateProvider>
    );
  }

  return (
    <GlobalStateProvider>
      <KoneEmployeeApp {...props}></KoneEmployeeApp>
    </GlobalStateProvider>
  );
};

export default App;
